"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LUCKY_HOURS = void 0;
exports.LUCKY_HOURS = ['110100101100', '001101001011', '110011010010', '101100110100', '001011001101', '010010110011'];
